import React from "react";
import { useSelector } from "react-redux";
import DictionaryContent from "layout/dictionary/DictionaryContent";
import DictionaryEditContent from "layout/dictionary/edit/DictionaryContent";
import { HashRouter, Navigate, Route, Routes } from "react-router-dom";
import { DICTIONARIES_HOME, NEW_DICTIONARY } from "constants/routes";
import ModalsHolder from "layout/discovery/ModalsHolder";
import { AlertsHolder } from "components/Alert";
import NavBar from "layout/navbar";
import SideBar from "layout/sidebar";

const Dictionary = () => {
  const { inline } = useSelector((state) => state.app.alerts);

  return (
    <div className="dictionary_page">
      <NavBar />
      <SideBar />
      <div style={{ height: "100%" }}>
        <ModalsHolder />
        <AlertsHolder />
        <div
          className={`dictionary${
            inline ? " dictionary__with_inline_alert" : ""
          }`}
          data-testid="dictionary-page"
        >
          <HashRouter>
            <Routes>
              <Route path={DICTIONARIES_HOME} element={<DictionaryContent />} />
              <Route path="/:id" element={<DictionaryEditContent />} />
              <Route
                path={NEW_DICTIONARY}
                element={<DictionaryEditContent />}
              />
              <Route
                path="*"
                element={<Navigate to={DICTIONARIES_HOME} replace />}
              />
            </Routes>
          </HashRouter>
        </div>
      </div>
    </div>
  );
};

export default Dictionary;
